import { useMutation } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { ApiError } from 'features/invite-users/useProjectInvitations';

const FREEZE_PROJECT = 'freezeProject';

interface FreezeProjectInput {
	projectId: number;
}

interface ProjectOperationResponse {
	statusCode: string;
}

interface UseProjectFreezeReturn {
	freezeProject: (details: FreezeProjectInput) => Promise<ProjectOperationResponse | void>;
	isFreezing: boolean;
}

export function useProjectFreeze(): UseProjectFreezeReturn {
	const freezeMutation = useMutation<ProjectOperationResponse, ApiError, FreezeProjectInput>(
		details =>
			makeRequest<ProjectOperationResponse>({
				service: 'projects',
				method: FREEZE_PROJECT,
				data: details
			}),
		{
			onError: (error: ApiError) => {
				console.error('Failed to freeze project (hook):', error);
			}
		}
	);

	const freezeProject = async (details: FreezeProjectInput) => {
		return freezeMutation.mutateAsync(details);
	};

	return {
		freezeProject,
		isFreezing: freezeMutation.isLoading
	};
}
